// import ProfilesContainer from "./ProfileContainer";
// import RolesContainer from "./RolesContainer";
// import DataSharingContainer from "./DataSharingContainer";
// import DataSharingRuleContainer from "./DataSharingRuleContainer";
// import ActionButtonContainer from "./ActionButtonContainer";
// import FieldAccessContainer from "./FieldAccessContainer";

import React from "react";
const ProfilesContainer = React.lazy(() => import('./ProfileContainer'));
const RolesContainer = React.lazy(() => import('./RolesContainer'));
const DataSharingContainer = React.lazy(() => import('./DataSharingContainer'));
const DataSharingRuleContainer = React.lazy(() => import('./DataSharingRuleContainer'));
const ActionButtonContainer = React.lazy(() => import('./ActionButtonContainer'));
const FieldAccessContainer = React.lazy(() => import('./FieldAccessContainer'));


export {
	ProfilesContainer,
    RolesContainer,
    DataSharingContainer,
    DataSharingRuleContainer,
    ActionButtonContainer,
    FieldAccessContainer
};
